import React from 'react';
import moment from 'moment';
import { BADI_COLORS } from 'app/badi-components';

import { Text, Flex, Spacer } from '@badi/badi-components';
import { BlockWrapper } from '../styled-components';
import { translate, locale } from 'base/shared/Localization';
import Calendar from 'components/Icons/Calendar';
import { Root, Image, TextWrapper } from './styled-components';

const BookingInfoWithRoom = ({
  title = '',
  address = '',
  picture = '',
  checkInDate = '',
  checkOutDate = '',
  currentRoomId,
}) => {
  return (
    <Root>
      <BlockWrapper>
        <Spacer bottom={2} top={2}>
          <Flex justify="flexStart" alignItems="center">
            <Image alt={title} src={picture} />
            <Spacer left={3} right={3} styles={{ width: '100%' }}>
              <TextWrapper>
                <Text body={2}>{title}</Text>
              </TextWrapper>
              <Text body={3}>{address}</Text>
            </Spacer>
          </Flex>
        </Spacer>
      </BlockWrapper>
      <BlockWrapper>
        <Spacer bottom={2} top={2}>
          <Flex alignItems="center" justify="spaceBetween">
            <div>
              <Text body={3}>{translate('booking.preview.movein_label')}</Text>
              <Text body={2} data-qa="room-available-from">
                {moment(checkInDate).locale(locale()).format('LL')}
              </Text>
            </div>
            <Calendar color={BADI_COLORS.NEUTRAL.NEUTRAL_50} />
            <div>
              <Text body={3}>{translate('booking.preview.moveout_label')}</Text>
              <Text body={2}>{moment(checkOutDate).locale(locale()).format('LL')}</Text>
            </div>
          </Flex>
        </Spacer>
      </BlockWrapper>
    </Root>
  );
};

export default BookingInfoWithRoom;
